
    import { defineComponent, SetupContext, ref, toRefs, watch } from 'vue'
    import Icon from '@/components/Icon/IndexIcon.vue'
    import useChat from '@/hooks/useChat'
    import useMessage from '@/hooks/useMessage'

    export default defineComponent({
        emits: ['onUpdate'],

        components: { Icon },

        props: {
            value: {
                type: String,
                required: true
            },
            focus: {
                type: Boolean,
                default: false
            },
            color: {
                type: String,
                default: '#C4C4C4'
            }
        },

        setup (props, { emit }: SetupContext) {
            const toogle = ref(false)
            const { setFocusTextarea } = useChat()
            const { setIsMessage } = useMessage()

            function handleClick () {
                setIsMessage(props.value)
                setFocusTextarea(true)
                toogle.value = false
            }

            watch(() => props.focus, (value) => {
                if (value === false) {
                    toogle.value = false
                }
            })

            return {
                toogle,
                handleClick,
                emit,
                ...toRefs(props)
            }
        }
    })
